/**
 * Measures label widths in CSS pixels with a cached canvas context.
 *
 * Estimating from character count underestimates by roughly a quarter for the
 * long English station names, which let labels overlap despite the collision
 * pass. Measuring is exact and, cached, costs nothing.
 */
const cache = new Map<string, number>();
let ctx: CanvasRenderingContext2D | null = null;

const FONT_FAMILY =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang TC", "Noto Sans TC", "Helvetica Neue", sans-serif';

export function measureLabel(text: string, fontCssPx: number): number {
  const key = `${fontCssPx}|${text}`;
  const hit = cache.get(key);
  if (hit !== undefined) return hit;

  if (!ctx) ctx = document.createElement('canvas').getContext('2d');
  if (!ctx) return text.length * fontCssPx * 0.85; // no canvas: overestimate rather than overlap

  ctx.font = `600 ${fontCssPx}px ${FONT_FAMILY}`;
  const w = ctx.measureText(text).width;
  cache.set(key, w);
  return w;
}
